import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { CollectRequestForm } from '../Forms';
import { Text1 } from '../../../styles';


const SendCollectRequestModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Send Collect Request
            </Text1>
        )
    };

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={() => props.toggleCollectRequestModal(props.virtualAccount)}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <CollectRequestForm
                onSubmit={props.onSubmit}
                loading={props.loading}
                virtualAccount={props.virtualAccount}
            />
        </EaseModal>
    )
};

export { SendCollectRequestModal };